import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Navigation, Pagination, Scrollbar, A11y } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import { BASE_URL } from '../../api/api'
import NavLink from '../navLink'

SwiperCore.use([Autoplay, Navigation, Pagination])

const Chart = ({
  data = [],
  className,
  pagePosition = 'right',
  width = '100%',
  height = 'auto'
}) => {
  const [index, setIndex] = useState(0)
  const onChange = ({ activeIndex }) => {
    setIndex(activeIndex)
  }

  return (
    <Swiper
      className={`home-chart overflow-visible ${className}`}
      spaceBetween={50}
      slidesPerView={1}
      navigation
      autoplay={{ delay: 3000 }}
      // pagination={{ clickable: true }}
      // scrollbar={{ draggable: true }}
      // onSwiper={onChange}
      onSlideChange={onChange}
    >
      {data.map(({ image = '' }, key) => (
        <SwiperSlide key={key}>
          <img style={{ width, height }} src={`${BASE_URL}${image || ''}`} alt="" />
        </SwiperSlide>
      ))}
      <div
        className={`h-[57px] w-full lg:w-full lg:absolute ${pagePosition}-0 bottom-[-29px] lg:h-[58px] flex justify-between z-10`}
      >
        <NavLink
          to={`/wzxq/id/${data[index]?.id}`}
          className={`flex-1 bg-[#0181C9] overflow-hidden whitespace-nowrap truncate px-[30px] leading-[57px] font-alhpr  lg:leading-[58px] text-white lg:text-xl font-bold`}
        >
          {data[index]?.title}
        </NavLink>
        <span className="bg-black text-white w-[54px] text-center leading-[58px]">
          {index + 1}/{data.length}
        </span>
      </div>
    </Swiper>
  )
}

export default Chart
